var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-video light--bg-blue"},[_c('div',{staticClass:"row max-width-md section-title pb-3 pt-6"},[_c('video-empresa')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }